import {DataBase} from './data-base';
import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';
import {DataTuplaDescription} from './data-tupla-description';
import {DataRow} from './data-row';

@jsonObject
export class DataSeries extends DataBase {
  @jsonMember
  private description: string;
  @jsonMember
  private unit: string;
  @jsonArrayMember(DataTuplaDescription)
  private columnsDescription: DataTuplaDescription[] = [];
  @jsonArrayMember(DataRow)
  private rows: DataRow[] = [];

  // Range null = not setted
  private rangeMin: number = null;
  private rangeMax: number = null;


  get Units(): string {
    return this.unit;
  }

  set Units(value: string) {
    this.unit = value;
  }

  get Description(): string {
    return this.description;
  }
  set Description(value: string) {
    this.description = value;
  }

  get TuplasDescription(): DataTuplaDescription[] {
    return this.columnsDescription;
  }
  set TuplasDescription(value: DataTuplaDescription[]) {
    this.columnsDescription = value;
  }
  get DataRows(): DataRow[] {
    return this.rows;
  }


  get RangeMin(): number {
    return this.rangeMin;
  }

  set RangeMin(value: number) {
    this.rangeMin = value;
  }

  get RangeMax(): number {
    return this.rangeMax;
  }

  set RangeMax(value: number) {
    this.rangeMax = value;
  }
}
